<div class="admin-layout" [class.sidebar-collapsed]="!isMobile && isSidebarCollapsed"
  [class.mobile-sidebar-open]="isMobile && isMobileSidebarOpen">
  <!-- Sidebar -->
  <aside class="admin-sidebar" [class.collapsed]="!isMobile && isSidebarCollapsed"
    [class.mobile-open]="isMobile && isMobileSidebarOpen">
    <div class="sidebar-header">
      <div class="logo">
        <img src="/dr.png" alt="Dr. Piyu's Height Clinic" class="logo-img">
        @if (!isSidebarCollapsed || isMobile) {
        <span class="logo-text">Dr. Piyu's Height Clinic</span>
        }
      </div>

      @if (isMobile) {
        <button class="mobile-close-btn" (click)="closeMobileSidebar()">
        <i class="fas fa-times"></i>
      </button>
      }
    </div>

    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li class="nav-item">
          <a routerLink="/admin/dashboard" routerLinkActive="active" (click)="setActiveMenu('dashboard')"
            class="nav-link">
            <i class="fas fa-tachometer-alt"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Dashboard</span>
            }
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/admin/orders" routerLinkActive="active" (click)="setActiveMenu('orders')" class="nav-link">
            <i class="fas fa-shopping-cart"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Orders</span>
            }
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/admin/products" routerLinkActive="active" (click)="setActiveMenu('products')"
            class="nav-link">
            <i class="fas fa-box"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Products</span>
            }
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/admin/categories" routerLinkActive="active" (click)="setActiveMenu('categories')"
            class="nav-link">
            <i class="fas fa-tags"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Categories</span>
            }
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/admin/users" routerLinkActive="active" (click)="setActiveMenu('users')" class="nav-link">
            <i class="fas fa-users"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Users</span>
            }
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/admin/site-content" routerLinkActive="active" (click)="setActiveMenu('settings')" class="nav-link">
            <i class="fas fa-image"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Site Content</span>
            }
          </a>
        </li>



        <!-- <li class="nav-item">
          <a routerLink="/admin/settings" routerLinkActive="active" (click)="setActiveMenu('settings')"
            class="nav-link">
            <i class="fas fa-cog"></i>
            @if (!isSidebarCollapsed || isMobile) {
            <span>Settings</span>
            }
          </a>
        </li> -->
      </ul>
    </nav>

    <div class="sidebar-footer">
      @if (!isSidebarCollapsed || isMobile) {
      <div class="user-info">
        <div class="user-avatar">
          <i class="fas fa-user"></i>
        </div>
        <div class="user-details">
          <span class="user-name">{{ currentUser?.name }}</span>
          <span class="user-role">{{ currentUser?.role }}</span>
        </div>
      </div>
      }
      <button class="logout-btn" (click)="logout()" title="Logout">
        <i class="fas fa-sign-out-alt"></i>
        @if (!isSidebarCollapsed || isMobile) {
        <span>Logout</span>
        }
      </button>
    </div>
  </aside>

  <!-- Mobile Overlay -->
  @if (isMobile && isMobileSidebarOpen) {
  <div class="mobile-overlay" (click)="closeMobileSidebar()"></div>
  }

  <!-- Main Content -->
  <main class="admin-main">
    <header class="admin-header">
      <div class="header-left">
        @if (isMobile) {
        <button class="mobile-menu-toggle" (click)="toggleSidebar()">
          <i class="fas fa-bars"></i>
        </button>
        }
        @if (!isMobile) {
        <button class="desktop-sidebar-toggle" (click)="toggleSidebar()">
          <i class="fas fa-bars"></i>
        </button>
        }
        <h1 class="page-title">{{ getPageTitle() }}</h1>
      </div>
      <div class="header-right">
        <div class="header-actions">
          <button class="notification-btn" 
                  (click)="toggleNotificationDrawer()" 
                  title="Notifications"
                  [class.has-notifications]="notificationCount > 0">
            <i class="fas fa-bell"></i>
            @if (notificationCount > 0) {
              <span class="notification-badge">{{ notificationCount }}</span>
            }
          </button>
          <div class="user-menu">
            <div class="header-avatar">
              <i class="fas fa-user"></i>
            </div>
            <span class="user-name">{{ currentUser?.name }}</span>
          </div>
        </div>
      </div>
    </header>

    <div class="admin-content">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Notification Drawer -->
  <app-notification-drawer 
    [isOpen]="isNotificationDrawerOpen"
    (closeDrawer)="closeNotificationDrawer()">
  </app-notification-drawer>
</div>